@if (isLoading) {
  <div class="loading-container">
    <div class="loading-spinner"></div>
    <p>Loading...</p>
  </div>
} @else {
  <router-outlet />
}
